export default __webpack_public_path__ + "static/media/checkers.fdea52c5.svg";